import React from "react"
import Box from "@mui/material/Box"

import './ProfilePage.scss'
import {ChangePassword} from "./ChangePassword"
import {DeskingSettings} from "./DeskingSettings"
import {AppearanceSettings} from "./AppearanceSettings"
import {CompanyLogoSettings} from "./CompanyLogoSettings"
import {SuperUserSettings} from "./SuperUserSettings"
import {useUserContext} from "../../contexts/UserContext"
import {useThemeStore} from "../../stores/themeStore"

export const ProfilePage = () => {
    const { profileState } = useUserContext()
    const theme = useThemeStore((state) => state.theme)

    if (!profileState?.default_location) return null

    return (
        <Box id="ProfilePage" data-theme={theme}>
            <div className={'profile-header'}>
                <h1 className={'profile-title'}>Profile</h1>
                <p className={'profile-subtitle'}>
                    Manage your account settings and customize how your brand appears.
                </p>
            </div>

            <Box className={'ProfilePage_container'}>
                {/* Left column: existing settings stack. */}
                <div className={'ProfilePage_column'}>
                    <AppearanceSettings/>
                    <ChangePassword/>
                    {
                        false &&
                        <DeskingSettings/>
                    }
                    {/* Renders only for superusers — the panel gates itself. */}
                    <SuperUserSettings/>
                </div>

                {/* Right column: logo management, using the remaining page width. */}
                <div className={'ProfilePage_column ProfilePage_column--wide'}>
                    <CompanyLogoSettings/>
                </div>
            </Box>
        </Box>
    )
}
